<template>
  <form
    class="input-group search-query-input-group"
    method="get"
    @submit.prevent="onSubmit"
  >
    <div class="field has-addons">
      <div class="control has-icons-left is-expanded">
        <input
          id="searchInput"
          ref="input"
          v-model="searchTermInternal"
          class="input"
          name="query"
          :placeholder="$texts('search_term', 'Suchbegriff eingeben')"
          type="search"
          spellcheck="false"
          role="searchbox"
          aria-owns="searchterm-suggestions"
          aria-label="Search input"
          @focus="isFocused = true"
          @search="updateSearchTerm"
        />
        <div class="icon is-left">
          <SpriteSymbol name="search" />
        </div>
      </div>
      <div class="control">
        <input
          class="button is-warning has-text-white"
          type="submit"
          :value="$texts('search_cta', 'Suchen')"
          @click.prevent="updateSearchTerm"
        />
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue?: string | null
}>()

const { $texts } = useNuxtApp()

const searchTermInternal = ref('')
const isFocused = ref(false)
const input = ref<HTMLInputElement | null>(null)

const emit = defineEmits(['update:modelValue'])

watch(
  () => props.modelValue,
  function (newValue) {
    searchTermInternal.value = newValue || ''
  },
)

function updateSearchTerm() {
  emit('update:modelValue', searchTermInternal.value)
}

onMounted(() => {
  searchTermInternal.value = props.modelValue || ''
})

const onSubmit = () => {}
</script>

<style lang="scss">
.search-query-input-group {
  .control {
    .icon.is-left {
      top: 50%;
      left: 0.25em;
      transform: translateY(-50%);
      svg {
        fill: currentColor;
        height: 1.5em;
        width: 1.5em;
      }
    }
  }
  .control {
    input {
      font-size: inherit;
    }
    @include tablet {
      font-size: $size-medium;
    }
    @include widescreen {
      font-size: $size-large;
    }
  }
}
</style>
